import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllContacts = createAsyncThunk(
  "Contact/FindAllContact",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindAllContact`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertContact = createAsyncThunk(
  "Contact/InsertContact",
  async (ContactData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/InsertContact`,
        ContactData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertContactFromOtherPlace = createAsyncThunk(
  "Contact/CommonInsertContact",
  async (ContactData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/CommonInsertContact`,
        ContactData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateContact = createAsyncThunk(
  "Contact/UpdateContact",
  async (ContactData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/UpdateContact`,
        ContactData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteContact = createAsyncThunk(
  "Contact/DeleteContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/DeleteContact`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Contact", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getContactByID = createAsyncThunk(
  "Contact/FindByIDContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/FindByIDContact`,
        { ID },
      );

      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        CountryCode: result?.CountryCode,
        MobileNo: result?.MobileNo,
        AlternateMobileNo: result?.AlternateMobileNo,
        EmailID: result?.EmailID,
        AlternateEmailID: result?.AlternateEmailID,
        ContactType: result?.ContactType,
        LeadSourceID: result?.LeadSourceID,
        CountryID: result?.CountryID,
        StateID: result?.StateID,
        CityID: result?.CityID,
        Pincode: result?.Pincode,
        Address: result?.Address,
        DateofBirth: result?.DateofBirth
          ? moment(result?.DateofBirth, "YYYY-MM-DD")?.toDate()
          : "",
        MaritalStatus: result?.MaritalStatus,
        MarriageAnniversary: result?.MarriageAnniversary
          ? moment(result?.MarriageAnniversary, "YYYY-MM-DD")?.toDate()
          : "",
        NoofKids: result?.NoofKids,
        FoodPreferenceID: result?.FoodPreferenceID,
        PassportNumber: result?.PassportNumber,
        PassportExpiry: result?.PassportExpiry
          ? moment(result?.PassportExpiry, "YYYY-MM-DD")?.toDate()
          : "",
        CustomerCategory: result?.CustomerCategory,
        CompanyName: result?.CompanyName,
        GSTNumber: result?.GSTNumber,
        Pancard: result?.Pancard,
        Tags: result?.Tags,
        Remarks: result?.Remarks,
        ContactVisa: result?.ContactVisa
          ? result?.ContactVisa?.map((visa: any) => {
              return {
                VisaCountryID: visa?.VisaCountryID ? visa?.VisaCountryID : null,
                VisaExpiryDate: visa?.VisaExpiryDate
                  ? moment(visa?.VisaExpiryDate, "YYYY-MM-DD")?.toDate()
                  : "",
              };
            })
          : [],
      } as any;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const assignContactToUser = createAsyncThunk(
  "AssignedUser/ContactAssignedUsers",
  async (LeadData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/ContactAssignedUsers`,
        LeadData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error assigning user to Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveContact = createAsyncThunk(
  "Contact/ActiveInActiveContact",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/ActiveInActiveContact`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const bulkUploadContacts = createAsyncThunk(
  "Contact/ManageContactBulkUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/ManageContactBulkUpload`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const downloadContactExcel = createAsyncThunk(
  "Contact/ExcelForContacts",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Contact/ExcelForContacts`,
        formData,
        { responseType: "arraybuffer" },
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Downloading contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const storeGoogleAccessToken = createAsyncThunk(
  "GoogleContacts/UpdateAccessToken",
  async (AccessToken: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GoogleContacts/UpdateAccessToken`,
        {
          AccessToken: AccessToken,
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error storing google access token:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const importGoogleContacts = createAsyncThunk(
  "GoogleContacts/ImportContact",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/GoogleContacts/ImportContact`,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error importing google contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const exportGoogleContacts = createAsyncThunk(
  "GoogleContacts/ExportContact",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/GoogleContacts/ExportContact`,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error exporting google contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const verifyGoogleAccessToken = createAsyncThunk(
  "GoogleContacts/VerifyGoogleAccessToken",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/GoogleContacts/VerifyGoogleAccessToken`,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error verifying google contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
